import { AccountMyReferralBanner } from "@/containers/profile/account-my-referral/account-my-referral-banner";
import { View } from "@/components/ui";
import { VisitList } from "../visit-list";
import { MakeABooking } from "@/containers/make-a-booking";
import { ServiceAllIcon } from "@/components/shared/icons";
import { SuggestionServiceSection } from "@/containers/suggestion-services";
import NoVisitsBike from "@/assets/images/3d-illus/no-visit-bike.png";
import { EmptyCard } from "@/components/shared/empty-card";
import { CalendarDots, CalendarX, MapPinArea } from "@/components/shared/icons";
import { useUpcomingVisit } from "@/containers/visits/use-upcoming-visit";

export const VisitsUpcoming = () => {
  const {
    isEmpty,
    isUnscheduledEmpty,
    next7daysQuery,
    next30daysQuery,
    unscheduledQuery,
  } = useUpcomingVisit();

  return (
    <View className="mb-6 flex flex-col gap-6 px-4 md:px-0">
      <View className="mt-4">
        <AccountMyReferralBanner />
      </View>
      {isEmpty ? (
        <>
          <EmptyCard
            src={NoVisitsBike}
            title="You don't have any upcoming visits"
            desc="Your scheduled services will appear here once booked."
          />
          <MakeABooking />
          <SuggestionServiceSection
            title="You might also want this"
            icon={ServiceAllIcon}
          />
        </>
      ) : (
        <>
          <VisitList
            query={next7daysQuery}
            title="Visits in the next 7 days"
            icon={MapPinArea}
          />
          {!isUnscheduledEmpty && (
            <VisitList
              query={unscheduledQuery}
              title="Unscheduled Visits"
              icon={CalendarX}
            />
          )}
          <VisitList
            query={next30daysQuery}
            title="Visits in the next 30 days"
            icon={CalendarDots}
          />
        </>
      )}
    </View>
  );
};
